module.exports = __webpack_public_path__ + "09e7ce4047e358b366ff7ce09b36dd41.svg";